import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { RETURNS } = API_ENDPOINTS;

export const returnsApi = {
  // Sold orders (confirmed/completed) with their products, so admin picks
  // the product a customer brought back. params: { q, from, to }.
  getReturnableSales: (params) => axiosInstance.get(RETURNS.RETURNABLE, { params }),

  // Logged returns. params: { status, type, from, to }.
  getReturns: (params) => axiosInstance.get(RETURNS.LIST, { params }),

  // Mark a sold product as returned (exchange or cash).
  createReturn: (data) => axiosInstance.post(RETURNS.LIST, data),

  // Resolve a return (completed / rejected).
  updateReturn: (id, data) => axiosInstance.patch(RETURNS.DETAIL(id), data),

  // SUPERADMIN: remove a wrongly-logged return (snapshotted to the deletion
  // ledger; a paid-out cash refund is refused). { reason? }
  deleteReturn: (id, data = {}) =>
    axiosInstance.delete(RETURNS.DETAIL(id), { data }),
};
